import dayjs from 'dayjs';

export function dateExpired(date?: string) {
  return date ? dayjs().isAfter(dayjs(date)) : false;
}
